module.exports = __webpack_public_path__ + "media/images/badge/fan-sfegatato-78fea50b2672635f4d0343554f4a19c1.png";